/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { Injectable } from '@angular/core';
import {
  DRAWING_ENGINE_TOOLS,
  HistoryService,
  LayersService,
  ObjectMoveTool,
  ObjectsPlacingService,
  PanZoomTool,
  SvgService,
  SvgTool,
} from '@bcl/drawing-control';

export const EditToolId = 'area-map-edit';
@Injectable()
export class EditTool extends SvgTool {
  public readonly id = EditToolId;
  public readonly icon = '';

  private panZoomTool: PanZoomTool;
  private objectMoveTool: ObjectMoveTool;

  constructor(
    engine: SvgService,
    historyService: HistoryService,
    layersService: LayersService,
    objectsPlacingService: ObjectsPlacingService
  ) {
    super(engine, historyService);
    this.panZoomTool = new PanZoomTool(<SvgService>engine, historyService);
    this.objectMoveTool = new ObjectMoveTool(
      engine,
      historyService,
      layersService,
      objectsPlacingService
    );
  }

  protected registerListeners(): void {
    this.panZoomTool.activate();
    this.objectMoveTool.activate();
  }

  protected removeListeners(): void {
    this.panZoomTool.deactivate();
    this.objectMoveTool.deactivate();
  }
}

export const editToolProvider = {
  provide: DRAWING_ENGINE_TOOLS,
  useClass: EditTool,
  multi: true,
};
